module.exports = __webpack_public_path__ + "static/media/Logo__Heroku.267da7fb.svg";